import { Merchant } from "breadcommon";
import { useContext, useMemo } from "react";
import { TransactionsContext } from "../firebaseio/TransactionsContext";

/**
 * Client-side index of unique merchants derived from transactions, keyed by
 * merchant name. When multiple transactions share a merchant name, the entry
 * with a logo (if any) is preferred.
 */
export function useMerchants(): Map<string, Merchant> {
  const transactions = useContext(TransactionsContext);

  return useMemo(() => {
    const byName = new Map<string, Merchant>();
    transactions.forEach((txn) => {
      if (txn.merchant === null) return;
      const existing = byName.get(txn.merchant.name);
      if (!existing || (existing.logo === null && txn.merchant.logo !== null)) {
        byName.set(txn.merchant.name, txn.merchant);
      }
    });
    return byName;
  }, [transactions]);
}
